import React, { Component } from 'react';
import { Checkbox, Button } from '../forms';
import withAuthProvider from '../../hoc/withAuthProvider';
import withFetch from '../../hoc/withFetch';
import { REACT_APP_API_BASE } from '../../config';
import './monitor.scss';

class Monitor extends Component {

    state = {
        isLoading: false,
        name: '',
        searchParameters: ''
    };

    removeQuestionMarkFromQuery(query) {
        if (!query) return '';
        
        return query.substring(1);
    }

    async getTokenHeaders() {
        const token = await this.props.getAccessToken();
        const headers = new Headers();
        const bearer = `Bearer ${token}`;
        headers.append('Authorization', bearer);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');

        return headers;
    }

    async saveWatch() {
        this.setState({
            isLoading: true
        });

        const headers = await this.getTokenHeaders();

        const rawResponse = await fetch(`${REACT_APP_API_BASE}/units/search/adddeletewatch`, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                name: this.state.name,
                searchParameters: this.removeQuestionMarkFromQuery(this.props.search.locationHandler.search)
            })
        });

        if (rawResponse.ok) {
            this.setState({
                isLoading: false,
            });
        }
    }

    handleNameChange(value) {
        this.setState({
            name: value
        });
    }

    render() {

        const props = this.props;

        return (
            <div className="monitor">
                <div className="monitor__container">
                    <label className="monitor__label" htmlFor="monitor-name">Namnge bevakningen</label>
                    <input className="monitor__input" id="monitor-name" 
                           type="text" 
                           name="monitor-name" 
                           value={this.state.name} 
                           onChange={(e) => this.handleNameChange(e.currentTarget.value)} />
                </div>
                <div className="monitor__container">
                    <label className="monitor__label">
                        <Checkbox />
                        <span>Meddela mig via e-post om något ändras</span>
                    </label>
                </div>
                <div className="monitor__container">
                    <Button type="button" 
                            modifiers={{
                                'form__button--fullwidth': true
                            }} 
                            onClick={() => this.saveWatch()}
                            disabled={this.state.name === ''}>Skapa bevakning</Button>
                </div>
                <div className="monitor__container monitor__container--flex">
                    <Button type="button" 
                            modifiers={{
                                'form__button--muted': true,
                                'form__button--centered': true
                            }}
                            onClick={() => props.toggleTakeover(!props.isOpen)}>Avbryt</Button>
                </div>
            </div>
        );
    }
};

export default withAuthProvider(withFetch(Monitor));